<!-- -->
<template>
  <div :class="{ geo: true, mm: isMobile }">
    <div class="box">
      <div class="section-head">
        <div class="title">服务优势</div>
        <button class="consult" @click="$emit('openDialog')">免费咨询</button>
      </div>
      <div class="advantage">
        <div class="list">
          <div
            class="item"
            v-for="(item, idx) in advantageList"
            :key="idx"
          >
            <span class="num">{{ idx + 1 }}、</span>
            <span class="label">{{ item.label }}：</span>
            <span class="text">{{ item.text }}</span>
          </div>
        </div>
        <div class="pic">
          <img :src="advantageImg" alt="GEO服务优势" />
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="section-head">
        <div class="title">应用场景</div>
        <button class="consult" @click="$emit('openDialog')">免费咨询</button>
      </div>
      <div class="scene-tabs">
        <div
          :class="{ tab: true, active: activeScene === idx }"
          v-for="(item, idx) in sceneList"
          :key="item.name"
          @click="activeScene = idx"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="scene-content">
        <template v-if="activeSceneData.items">
          <div
            class="scene-item"
            v-for="(item, idx) in activeSceneData.items"
            :key="idx"
          >
            <span class="num">{{ idx + 1 }}、</span>
            <span class="label">{{ item.label }}：</span>
            <span class="text">{{ item.text }}</span>
          </div>
        </template>
        <div class="scene-desc" v-else>{{ activeSceneData.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      activeScene: 0,
      advantageImg: "./geo/advantage.png",
      advantageList: [
        {
          label: "全平台全覆盖",
          text: "国内覆盖豆包、DeepSeek、千问等亿级 AI 大模型；外贸版覆盖 Google AI、ChatGPT、Gemini、Copilot，多平台随机投放，流量入口广。",
        },
        {
          label: "上线快、词量足",
          text: "核心词福利政策友好，套餐配置多梯度关键词，可灵活拓展海量长尾词。",
        },
        {
          label: "内容智能 + 权威背书",
          text: "AI + 人工原创产出文章 / 问答 / 媒体稿件；背靠官媒、门户网站、B2B 三级媒体矩阵，高权重投喂提升 AI 收录与推荐权重。",
        },
        {
          label: "数据可视 + 托管省心",
          text: "实时报表可查排名、上词情况，每周数据监控优化；无需客户复杂操作，全程托管，国内官网隔翻即可用。",
        },
        {
          label: "降本增效、长期复利",
          text: "大幅低于传统营销获客成本，转化表现优异；一次布局长期受益，减少竞价依赖，稳步构筑行业竞争壁垒。",
        },
        {
          label: "技术合规 + 服务完善",
          text: "产品合规备案、安全可控，可挂载官网与联系渠道；搭配智能建站、数字人咨询、私域运营，形成完整营销闭环。",
        },
      ],
      sceneList: [
        {
          name: "全行业通用",
          desc: "适用于机械设备、化工、商务服务、生活服务、医疗、教育、律所、新能源、装饰建材等百余个行业，解决企业线上获客难、传统 SEO 流量下滑、竞价广告成本高的痛点。",
        },
        {
          name: "国内品牌营销",
          items: [
            {
              label: "品牌曝光种草",
              text: "想在豆包、DeepSeek 等国民级 AI 平台抢占问答入口，让用户 AI 提问时优先看到自身品牌。",
            },
            {
              label: "口碑塑造",
              text: "通过权威媒体内容投喂，沉淀正向品牌信息，塑造行业口碑。",
            },
            {
              label: "中小微企业轻量化营销",
              text: "无专业运营团队、预算有限，想低成本布局 AI 流量，无需复杂技术搭建即可快速上线。",
            },
          ],
        },
        {
          name: "外贸出海拓客",
          items: [
            {
              label: "跨境 B2B 获客",
              text: "面向全球采购商，在 Google AI Overview、ChatGPT、Gemini 等海外 AI 模型布局产品关键词，承接海外 AI 搜索采购需求。",
            },
            {
              label: "海外品牌布局",
              text: "抢占海外 AI 月活 15 亿 + 流量红利，覆盖 60% 无二次跳转的 AI 搜索用户，提前建立海外行业竞争壁垒。",
            },
            {
              label: "工厂 / 外贸商家拓客",
              text: "生产厂家、跨境供应商借助 AI 问答排名，获取精准海外询盘，替代部分传统展会、B2B 平台获客渠道。",
            },
          ],
        },
        {
          name: "窗口期战略卡位",
          items: [
            {
              label: "AI 全民普及窗口期",
              text: "春晚等全民 AI 热潮后，用户习惯彻底重塑，企业刚需布局 AI 数字生命线，抢占早期低成本红利。",
            },
            {
              label: "AI 商业化前夕卡位",
              text: "趁 AI 尚未全面会员制、收费化阶段，提前锁定 AI 问答固定席位，避免后期入局成本走高。",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
    activeSceneData() {
      return this.sceneList[this.activeScene];
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 1200px;
  margin: 100px auto 0;
  padding-bottom: 80px;
}
.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 120px;
}
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 44px;
      height: 4px;
      background-color: $theme;
      margin-top: 8px;
    }
  }
  .consult {
    width: 140px;
    height: 44px;
    border-radius: 22px;
    background-color: $theme;
    color: #fff;
    font-size: 18px;
  }
}
.advantage {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .list {
    flex: 1;
    padding-right: 60px;

    .item {
      color: #6e7685;
      font-size: 15px;
      line-height: 28px;
      letter-spacing: 1px;
      margin-bottom: 22px;

      .label {
        color: #2a2f39;
        font-weight: bold;
      }
    }
  }
  .pic {
    width: 420px;
    flex-shrink: 0;

    img {
      width: 100%;
      display: block;
      border-radius: 8px;
    }
  }
}
.box2 .section-head,
.scene-tabs,
.scene-content {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.scene-tabs {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;

  .tab {
    flex: 1;
    height: 56px;
    line-height: 56px;
    text-align: center;
    border: 1px solid #d8dce3;
    border-radius: 28px;
    color: #6e7685;
    font-size: 18px;
    cursor: pointer;
    position: relative;
    transition: color 0.3s, border-color 0.3s;

    &:hover {
      color: $theme;
      border-color: $theme;
    }
  }
  .active {
    color: $theme;
    border-color: $theme;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -12px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-width: 8px;
      border-style: solid;
      border-color: $theme transparent transparent transparent;
    }
  }
}
.scene-content {
  padding-top: 20px;
  border-top: 1px dashed #d8dce3;

  .scene-item {
    color: #6e7685;
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 1px;
    margin-bottom: 18px;

    .label {
      color: #2a2f39;
      font-weight: bold;
    }
  }
  .scene-desc {
    color: #6e7685;
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 1px;
  }
}

.mm {
  .box,
  .box2 .section-head,
  .scene-tabs,
  .scene-content {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
  }
  .box {
    margin-top: 60px;
    padding-bottom: 40px;
  }
  .box2 {
    padding: 40px 0 60px;
  }
  .section-head {
    margin-bottom: 30px;

    .title {
      font-size: 22px;
    }
    .consult {
      width: 100px;
      height: 36px;
      font-size: 14px;
    }
  }
  .advantage {
    flex-direction: column;

    .list {
      padding-right: 0;

      .item {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 16px;
      }
    }
    .pic {
      width: 100%;
      margin-top: 20px;
    }
  }
  .scene-tabs {
    flex-wrap: wrap;
    gap: 10px;

    .tab {
      flex: unset;
      width: calc(50% - 5px);
      height: 44px;
      line-height: 44px;
      font-size: 14px;
    }
  }
  .scene-content {
    .scene-item,
    .scene-desc {
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

@media (max-width: 1400px) {
  .box,
  .box2 .section-head,
  .scene-tabs,
  .scene-content {
    width: 1000px;
  }
  .advantage .pic {
    width: 360px;
  }
}
</style>
